import { CountUp } from 'countup.js';

const toggles = document.querySelectorAll('[data-toggle="price"]');
const pricingLinks = document.getElementsByClassName('pricing-link');
const DURATION = 1;

toggles.forEach(toggle => {
  toggle.addEventListener('change', (e) => {
    const input = e.target;
    const isChecked = input.checked;

    const target = input.dataset.target;
    const targets = document.querySelectorAll(target);

    targets.forEach(target => {
      try {
        const annual = target.dataset.annual;
        const monthly = target.dataset.monthly;
        const options = target.dataset.options ? JSON.parse(target.dataset.options) : {};

        options.startVal = isChecked ? annual : monthly;
        options.duration = options.duration ? options.duration : DURATION;

        const countUp = isChecked ? new CountUp(target, monthly, options) : new CountUp(target, annual, options);

        countUp.start();
      } catch (err) {
        // price animation failed — link update still runs below
      }
    });

    Array.from(pricingLinks).forEach(pricingLink => {
      try {
        const links = JSON.parse(pricingLink.getAttribute('data-links'));
        pricingLink.href = isChecked ? links.annual : links.monthly;
      } catch (err) {
        // malformed data-links on this card
      }
    });
  });
});
